import './App.css';
import { forwardRef } from 'react';
import ProjectsHome from './components/Projects2/Projects_Home';
import ProjectDetail from './components/Projects2/ProjectDetail';
import Naving from './components/Naving';
import History from './components/History/History';
import Skills from './components/Skills/Skills';
import TravelPage from './components/Travel/TravelPage';
import PageTransition from './components/Transitions/PageTransition';
import { NavigationProvider } from './components/Transitions/NavigationContext';
import BlossomScene from './components/Blossom/LazyBlossomScene';

import { BrowserRouter as Router, Route, Routes, Navigate, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';

// React Router's Routes is a plain function component, so AnimatePresence's
// PopChild can't attach its measurement ref to it directly (warning in dev).
// Wrapping Routes in a forwardRef shell with `display: contents` gives PopChild
// a real DOM node to ref without introducing a layout box.
const RoutesShell = forwardRef(function RoutesShell({ location, children }, ref) {
  return (
    <div ref={ref} style={{ display: 'contents' }}>
      <Routes location={location}>{children}</Routes>
    </div>
  );
});

function AnimatedRoutes() {
  const location = useLocation();
  return (
    <AnimatePresence mode="popLayout" initial={false}>
      <RoutesShell key={location.pathname} location={location}>
        <Route exact path="/" element={<PageTransition><ProjectsHome /></PageTransition>} />
        <Route exact path="/Projects" element={<PageTransition><ProjectsHome /></PageTransition>} />
        <Route path="/projects/:slug" element={<PageTransition><ProjectDetail /></PageTransition>} />
        <Route exact path="/WhatIDo" element={<PageTransition><Skills /></PageTransition>} />
        <Route exact path="/Experience" element={<PageTransition><History /></PageTransition>} />
        {/* Legacy paths — keep redirects so existing links / bookmarks land
            on the renamed pages instead of bouncing to the homepage. */}
        <Route exact path="/Skills" element={<Navigate to="/WhatIDo" replace />} />
        <Route exact path="/WhoAmI" element={<Navigate to="/WhatIDo" replace />} />
        <Route exact path="/History" element={<Navigate to="/Experience" replace />} />
        <Route exact path="/Travel" element={<PageTransition><TravelPage /></PageTransition>} />
        <Route path='*' element={<Navigate to='/' />} />
      </RoutesShell>
    </AnimatePresence>
  );
}

function App() {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <NavigationProvider>
        <Naving />
        <BlossomScene />
        <AnimatedRoutes />
      </NavigationProvider>
    </Router>
  );
}

export default App;
